/**
 * HUB-D — Onglets sections caisse (journalier / mensuel).
 */
import React from 'react';
import { CAISSE_SECTIONS } from '../../utils/caisse/caisseDisplay';

const SECTIONS = [
  { id: CAISSE_SECTIONS.JOURNALIER, label: 'Vue journalière' },
  { id: CAISSE_SECTIONS.MENSUEL, label: 'Vue mensuelle' },
];

export default function ActiviteCaisseSectionTabs({ activeSection, onSectionChange, counts = {} }) {
  return (
    <div className="flex gap-2 flex-wrap" data-testid="activite-caisse-section-tabs">
      {SECTIONS.map((section) => {
        const isActive = activeSection === section.id;
        const count = counts[section.id];
        return (
          <button
            key={section.id}
            type="button"
            onClick={() => onSectionChange(section.id)}
            className={`px-4 py-2.5 min-h-[44px] rounded-xl text-sm font-semibold border transition-all ${
              isActive ? 'text-[var(--rm-white)]' : 'text-[var(--rm-gray-400)]'
            }`}
            style={{
              borderColor: isActive ? 'var(--rm-border-strong)' : 'var(--rm-border-subtle)',
              background: isActive ? 'var(--rm-bg-panel)' : 'transparent',
            }}
            data-testid={`activite-caisse-section-${section.id}`}
          >
            {section.label}
            {count != null && (
              <span className="ml-1.5 px-1.5 py-0.5 rounded-full text-xs rm-badge rm-badge--muted">{count}</span>
            )}
          </button>
        );
      })}
    </div>
  );
}
